__turbopack_context__.v({
  "docSvg": "Tn3Rya_docSvg",
});
